// Category metadata for Xavi reply entity actions (3 categories in scope).

export const ENTITY_CATEGORIES = [
  { key: 'artists', label: 'Artists', icon: '♪' },
  { key: 'events', label: 'Events & Festivals', icon: '◉' },
  { key: 'venues', label: 'Venues', icon: '⌂', dir: 'venues' },
  { key: 'shows', label: 'Shows', icon: '▦' },
];

export const EMPTY_ENTITIES = {
  artists: [],
  events: [],
  venues: [],
  shows: [],
};

// Validate and normalize the extracted names. Treats absent or malformed
// category values as empty lists; dedupes case-insensitively.
export function normalizeEntities(raw) {
  const e = { ...EMPTY_ENTITIES };
  if (!raw || typeof raw !== 'object') return e;
  for (const k of Object.keys(EMPTY_ENTITIES)) {
    const arr = raw[k];
    if (!Array.isArray(arr)) {
      e[k] = [];
      continue;
    }
    e[k] = arr
      .map((o) => (typeof o === 'string' ? { name: o } : o))
      .filter((o) => o && typeof o.name === 'string' && o.name.trim())
      .map((o) => {
        const item = { name: String(o.name).trim().slice(0, 120) };
        if (k === 'events') item.type = o.type === 'festival' ? 'festival' : 'event';
        const uuid = String(o.uuid || o.id || o.identifier || '').trim();
        if (uuid) item.uuid = uuid.slice(0, 120);
        return item;
      })
      .filter((o, i, arr) => arr.findIndex((x) => x.name.toLowerCase() === o.name.toLowerCase()) === i);
  }
  return e;
}
